import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Location} from '@on-the-go-web/sdk';
import {LocationPickerList} from '../location-picker-list/location-picker-list';

export interface LocationPickerSheetData {
  locations: Location[];
  currentLocationId: string | null;
}

// Opened from the bottom nav's data tab when the account has more than one
// location — lets the user switch location and land on that location's data
// page in one step, rather than a plain link that only ever goes to the
// current one.
@Component({
  selector: 'otg-location-picker-sheet',
  imports: [LocationPickerList],
  templateUrl: './location-picker-sheet.html',
  styleUrl: './location-picker-sheet.scss',
})
export class LocationPickerSheet {
  private _sheetRef = inject(MatBottomSheetRef<LocationPickerSheet>);
  private _router = inject(Router);
  private _data = inject<LocationPickerSheetData>(MAT_BOTTOM_SHEET_DATA);

  locations = this._data.locations;
  currentLocationId = this._data.currentLocationId;

  selectLocation(locationId: string): void {
    this._sheetRef.dismiss();
    this._router.navigate(['/l', locationId, 'data']);
  }

  addLocation(): void {
    this._sheetRef.dismiss();
    this._router.navigate(['/add-business']);
  }
}
